export default __webpack_public_path__ + "images/ebaa3ef34313f7820ec1b8ac528ca5ed.svg";